namespace TabAurous.Production {
    export interface ProductionBOMRow {
        TransBomId?: number;
        TransItemId?: number;
        TransId?: number;
        ProductId?: number;
        BomProductId?: number;
        ProductCode?: string;
        CalcOnId?: number;
        AttributeId?: number;
        BagNo?: string;
        LotNo?: string;
        Line_No?: number;
        Pieces?: number;
        Weight?: number;
        Purity?: number;
        PureWeight?: number;
        IsCustomerItem?: boolean;
        SettingId?: number;
        SettingName?: string;
        StoneStatusId?: number;
        StoneStatusName?: string;
        BomRate?: number;
        BomAmount?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        RefTransBomId?: number;
        Markup?: number;
        Lab?: string;
        CertificateNo?: string;
        HasBom?: boolean;
        ItemTypeId?: number;
        ProductTypeId?: number;
        SubCategoryId?: number;
        CategoryId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        KaratId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
    }

    export namespace ProductionBOMRow {
        export const idProperty = 'TransBomId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.ProductionBOM';
        export const deletePermission = 'Production:Production:Delete';
        export const insertPermission = 'Production:Production:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:Production:Edit';

        export declare const enum Fields {
            TransBomId = "TransBomId",
            TransItemId = "TransItemId",
            TransId = "TransId",
            ProductId = "ProductId",
            BomProductId = "BomProductId",
            ProductCode = "ProductCode",
            CalcOnId = "CalcOnId",
            AttributeId = "AttributeId",
            BagNo = "BagNo",
            LotNo = "LotNo",
            Line_No = "Line_No",
            Pieces = "Pieces",
            Weight = "Weight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            IsCustomerItem = "IsCustomerItem",
            SettingId = "SettingId",
            SettingName = "SettingName",
            StoneStatusId = "StoneStatusId",
            StoneStatusName = "StoneStatusName",
            BomRate = "BomRate",
            BomAmount = "BomAmount",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            RefTransBomId = "RefTransBomId",
            Markup = "Markup",
            Lab = "Lab",
            CertificateNo = "CertificateNo",
            HasBom = "HasBom",
            ItemTypeId = "ItemTypeId",
            ProductTypeId = "ProductTypeId",
            SubCategoryId = "SubCategoryId",
            CategoryId = "CategoryId",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth"
        }
    }
}
